import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IApprovalTaskItem, IApprovalTaskItemInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ApprovalTaskItemApiService {

  abstract getItem(id: string): Observable<IApprovalTaskItem>;

  abstract saveItem(approvalTaskItem: IApprovalTaskItemInput, applicationId: String, approvalTaskId: String | null): Observable<any>;

  abstract deleteItem(approvalTaskItemId: String,applicationId:String): Observable<any>;

  
  abstract deactivateItem(approvalTaskItemId: String,applicationId:String): Observable<any>;
}